import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the OrderConfirmationSummaryPage component.
 * Consolidates 11 individual useSelector calls into one, reducing re-renders
 * by only recalculating when cashStore or userStore change.
 */
export const selectOrderConfirmationSummaryPageContext = createSelector(
  [(state: RootState) => state.cashStore, (state: RootState) => state.userStore],
  (cashStore, userStore) => ({
    cartShippingMethod: cashStore.cashCartShippingMethod,
    cartShippingCost: cashStore.cashCartShippingCost,
    isFeeWaiveOverride: cashStore.isFeeWaiveOverride,
    cartDiscount: cashStore.cashCartDiscount,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    cartRequestedName: cashStore.cashCartRequestedName,
    cartRequestedPhone: cashStore.cashCartRequestedPhone,
    cartCaseNumber: cashStore.cashCartCaseNumber,
    cartPurchaseOrderNumber: cashStore.cashCartPurchaseOrderNumber,
    digitalCartOnly: cashStore.isDigitalCartOnly,
  })
);
